/* eslint-disable no-unused-vars */
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import LegacyMissionPage from './pages/LegacyMissionPage';
import LegacyRewardPage from './pages/LegacyRewardPage';
import LegacyUserRewardPage from './pages/LegacyUserRewardPage';
import LegacyMissionRedeemPage from './pages/LegacyMissionRedeemPage';
import LegacyMissionRewardBannerPage from './pages/LegacyMissionRewardBannerPage';

const queryClient = new QueryClient();

export default ({ match }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <Switch>
        <Route
          path={`${match.path}/mission`}
          exact
          children={<LegacyMissionPage />}
        />
        <Route
          path={`${match.path}/reward`}
          exact
          children={<LegacyRewardPage />}
        />
        <Route
          path={`${match.path}/reward/:rewardId`}
          exact
          children={<LegacyUserRewardPage />}
        />
        <Route
          path={`${match.path}/point`}
          exact
          children={<LegacyMissionRedeemPage />}
        />
        <Route
          path={`${match.path}/reward_banner`}
          exact
          children={<LegacyMissionRewardBannerPage />}
        />
      </Switch>
    </QueryClientProvider>
  );
};
